import { useKeycloak } from '@react-keycloak/web';
import { useEffect } from 'react';

export function useKeycloakTokenRefresh() {
  const { keycloak } = useKeycloak();

  useEffect(() => {
    if (!keycloak) return;

    const refreshInterval = setInterval(() => {
      if (keycloak.authenticated) {
        keycloak
          .updateToken(60) // if token will expire in less than 60 seconds, refresh
          .then(refreshed => {
            if (refreshed) {
            } else {
            }
          })
          .catch(() => {
            console.error('Failed to refresh token');
            keycloak.logout();
          });
      }
    }, 60000); // Check every 60 seconds

    return () => clearInterval(refreshInterval); // Clean up when component unmounts
  }, [keycloak]);
}
